/* eslint-disable @typescript-eslint/no-use-before-define */
import {
    Action,
    ActionReducerMap,
    createFeatureSelector,
    createSelector,
    StoreModule,
} from '@ngrx/store';
import { CommunityItem } from 'src/app/models/community-item';
import {
    AddForceCommunityItemRefresh,
    AddMyCommunityItem,
    CommunityItemAction,
    RemoveMyCommunityItem,
    SetMyCommunityItems,
} from './community-item.actions';

export interface CommunityItemState {
    myCommunityItems: CommunityItem[];
    forceItemRefreshList: string[];
}

const reducerMap: ActionReducerMap<CommunityItemState> = {
    forceItemRefreshList: forceItemRefreshListReducer,
    myCommunityItems: myCommunityItemsReducer,
};

export const selectCommunityItemState =
    createFeatureSelector<CommunityItemState>('communityItem');

export const selectMyCommunityItems = createSelector(
    selectCommunityItemState,
    (state) => state.myCommunityItems
);

export const selectCommunityForceRefreshList = createSelector(
    selectCommunityItemState,
    (state) => state.forceItemRefreshList
);

export const communityItemStoreModule = StoreModule.forFeature(
    'communityItem',
    reducerMap
);

function myCommunityItemsReducer(
    state: CommunityItem[] = [],
    action: Action
): CommunityItem[] {
    switch (action.type) {
        case CommunityItemAction.setMyCommunityItems:
            return (action as SetMyCommunityItems).items;
        case CommunityItemAction.addMyCommunityItem:
            return [
                ...state.filter(
                    (item) => item.id !== (action as AddMyCommunityItem).item.id
                ),
                (action as AddMyCommunityItem).item,
            ];
        case CommunityItemAction.removeMyCommunityItem:
            return state.filter(
                (item) => item.id !== (action as RemoveMyCommunityItem).id
            );
        default:
            return state;
    }
}

function forceItemRefreshListReducer(
    state: string[] = [],
    action: Action
): string[] {
    switch (action.type) {
        case CommunityItemAction.AddForceCommunityItemRefresh:
            return [
                ...state.filter(
                    (x) =>
                        x !==
                        (action as AddForceCommunityItemRefresh).communityItemId
                ),
                (action as AddForceCommunityItemRefresh).communityItemId,
            ];
        case CommunityItemAction.RemoveForceCommunityItemRefresh:
            return [];
        default:
            return state;
    }
}
